import React, { useState, useEffect } from "react";

function Header({ type }) {
  const [msg, setMsg] = useState("");

  useEffect(() => {
    switch (type) {
      case "application_status":
        setMsg(
          "Hey there! In order to check your application results, please fill out all required fields (*). Please make sure that you provide us with the same details you used during your application so we can find it in our database."
        );
        break;
      case "customer_service":
      case "leadership":
      case "multilingual":
      case "ojt":
      case "job_vacancy":
        setMsg(
          "Hey there! Kindly fill out the requried fields (*) below so we can help you fast track your application. Please expect a call from us for the next steps. Keep your lines open as we try to give you a call anytime from 9AM-6PM, Mondays to Fridays. Good luck!"
        );
        break;
      default:
        break;
    }
  }, [type]);

  return (
    <header
      style={{ background: "#039be5" }}
      className="border-b border-gray-800"
    >
      <div className="flex flex-wrap md:flex-no-wrap items-center justify-between max-w-4xl mx-auto p-4 md:p-8">
        <h5
          style={{ fontFamily: "Arial, Helvetica, sans-serif" }}
          className="text-sm text-white text-justify leading-normal"
        >
          {msg}
        </h5>
      </div>
    </header>
  );
}

export default Header;
